import { api } from 'app/config/apiConfig';
import { Discount } from '../model/types';

export const deleteDiscountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteDiscount: builder.mutation<Discount, string>({
      query: (discountId: string) => ({
        url: `/discounts/${discountId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Discounts'],
    }),
  }),
});

export const { useDeleteDiscountMutation } = deleteDiscountApi;
